import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="page page-notfound">
      <h1>404</h1>
      <p>No route here.</p>
      <Link to="/" className="btn btn-primary">
        Back home
      </Link>
    </div>
  );
}
